import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { MdOutlineMeetingRoom } from 'react-icons/md'
import Button from 'react-bootstrap/Button'
import '../Room Master/room.css'
import Header from './Header'
import Sidebar from './sidebar'
import { BlockFindAllApi, ImagePath, RoomAllocateListApi } from '../../ApiFile'
import axios from 'axios'
import { toast } from 'react-toastify'

const RoomBooking = () => {
  const navigate = useNavigate()
  const { block_id } = useParams()
  const [rooms, setRooms] = useState([])
  const [blocks, setBlocks] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchRooms = async () => {
      setLoading(true)
      const formData = {
        block_id: block_id,
      }
      axios
        .post(`${RoomAllocateListApi}`, formData)
        .then((response) => {
          if (response.data !== null) {
            const Data = response.data
            const roomNumbers = Data[0].room_range.split(',')
            const fetchedRooms = roomNumbers.map((number, index) => ({
              id: index + 1,
              number: number.trim(),
              occupied: false,
              room_img: Data[0].room_img, // Add the room image here
              bed_img: Data[0].bed_img, // Add the bed image here
            }))
            setRooms(fetchedRooms)
            setLoading(false)
          } else if (response.data == 'ERROR') {
            setLoading(false)
            toast.error('Error occurred while saving data')
          }
        })

        .catch((error) => {
          setError(error)
          console.error('Error uploading files:', error)
          setRooms([])
        })
    }

    fetchRooms() // Call fetchRooms when component mounts or block_id changes
  }, [block_id])

  const handleRoomSelect = (room_id) => {
    const selectedRoom = rooms.find((room) => room.number === room_id)
    if (!selectedRoom.occupied) {
      navigate(`/bed/${block_id}/${room_id}`)
    }
  }

  const handlePreviousClick = () => {
    navigate(`/?block_id=${block_id}`)
  }
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false)

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle)
  }

  useEffect(() => {
    fetchBlocks()
  }, [])

  const fetchBlocks = async () => {
    try {
      const response = await fetch(BlockFindAllApi)
      if (!response.ok) {
        throw new Error('Failed to fetch blocks')
      }
      const data = await response.json()
      setBlocks(data)
    } catch (error) {
      console.error('Error fetching blocks:', error)
    }
  }

  return (
    <>
     <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh', }}>
            {/* Sidebar on the left for desktop */}
            {/* <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
              <Sidebar />
            </div> */}
      
            {/* Main content on the right */}
            <div className="main-content flex-grow-1" style={{ flex: 1, }}>
              <Header />

              <div className="room-booking pb-5 rounded px-3 shadow" style={{backgroundColor:"#fff"}}>
                <div className="row m-0 block-header ps-3">
                  <h5 className="main-title1 room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
                    Select the Room
                  </h5>
                </div>

                {loading ? (
                  <p>Loading...</p>
                ) : error ? (
                  <p className="error-message">
                    Error fetching rooms: {error.message}
                  </p>
                ) : (
                  <div className="room-container-wrapper d-flex row m-0 px-3">
                    <div className="room-container main-cards1 col-md-8">
                      {rooms.length === 0 ? (
                        <p>No rooms available</p>
                      ) : (
                        rooms.map((room) => (
                          <div
                            key={room.id}
                            className={`room-card ${
                              room.occupied ? 'occupied' : 'unoccupied'
                            }`}
                            onClick={() => handleRoomSelect(room.number)}
                          >
                            <div className="room-card-inner">
                              <MdOutlineMeetingRoom size={28} className="room-icon" />
                              <span className="room-label">Room {room.number}</span>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                    <div className="col-md-4 d-flex justify-content-center align-items-center">
                      {rooms.length > 0 && (
                        <img
                          src={`${ImagePath}/${rooms[0].bed_img}`}
                          alt={rooms[0].bed_img}
                          className="rounded shadow"
                          style={{
                            mixBlendMode: 'darken',
                            height: '200px',
                            width: '250px',
                          }}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>

            </div>
      </div>
    </>
  )
}

export default RoomBooking
